import React, { useState, useEffect } from "react";
import assets from "../assets/imgs"
import Pagination from "./Pagination";
import BoardWriteBox from "./BoardWriteBox";
import config from "../config/config";
const API_URL = config.API_URL;

function MyPageAnnounceBoard({style}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const handleClick = (_id) =>{
    setSelectedId(_id);
    setIsModalOpen(true);
  }

  const handleClose = ()=>{
    setIsModalOpen(false);
  }

  // API 호출 함수
  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/board/getAnnounceList`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result.value);

      if (result.result && Array.isArray(result.value)) {
        // 데이터를 변환하여 company -> startup_name 매핑
        const formattedData = result.value.map((row, index) => ({
          _id: row._id || index + 1, // ID 설정
          id: index + 1,
          title : row.title || '-',
          date : row.up_date ? row.up_date.split("T")[0]: "-",
        }));
        setData(formattedData);
      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching board data:", error);
      // setError(error.message); // 에러 메시지 저장
    } finally {
      setLoading(false); // 데이터 로딩 완료
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지 상태
  const itemsPerPage = 6; // 페이지당 항목 수

  // 더미 데이터 (공지사항 리스트)
  const allItems = Array.from({ length: 20 }, (_, index) => ({
    title: `공지사항 ${index + 1}`,
    date: `2024-12-${index + 1}`,
  }));

  // 현재 페이지에 표시할 항목 계산
  const startIndex = (currentPage - 1) * itemsPerPage;
  const items = data.slice(startIndex, startIndex + itemsPerPage);

  // 총 페이지 수 계산
  const totalPages = Math.ceil(data.length / itemsPerPage);

  return (
    <>
      {loading ? (
        <p>Loading...</p>
      ):(
        <>
          <div className="commonComponent" style={{...style, padding: "20px 34px 30px 34px", position: "relative", }}>
            {/* 헤더 */}
            <div style={styles.headSide}>
              <h1 className="font-s-head4-bold">공지사항</h1>
              <img className="icon-kebab" src={assets.icons.kebab}/>
            </div>

            {/*공지사항 리스트  */}
            <div style={styles.board}>
              <ul style={styles.list}>
                {items.map((item, index) => (
                  <li key={index} style={index === 0 ? {...styles.listItem, ...styles.firstListItem} : styles.listItem}
                    onClick={() => handleClick(item._id)}>
                    <div style={styles.listHeader}>
                      <div className="font-body4-semibold" style={styles.listType}>공지</div>
                      <div className="font-body3-medium" style={{flex : 1}}>{item.title}</div>
                    </div>
                    <div style={styles.meta}>{item.date}</div>
                  </li>
                ))}
              </ul>        
            </div>
            {/* 페이지네이션 */}
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              style= {{position: "absolute",
                bottom: "15px",
                left: "50%",
                transform: "translateX(-50%)",}}
            />
          </div>
          {isModalOpen && (
            <BoardWriteBox boardTypeId={"Announce"} boardTypeName={"공지사항"} onClose={handleClose} boardId={selectedId} edit={false}/>
          )}
        </>
      )}
    </>
  );  
}

const styles = {
  headSide: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "14px",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#333",
  },
  kebab: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
  },
  board: {
    // backgroundColor: "#fff",
    // padding: "10px",
    // borderRadius: "8px",
    // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  list:{

  },
  firstListItem:{
    borderTop: "1px solid var(--grayscale_20)"
  },

  listItem: {
    boxSizing: "border-box",
    height: "48px",
    display: "flex",
    justifyContent: "space-between",
    padding: "12px",
    alignItems: "center",
    borderBottom: "1px solid var(--grayscale_20)",
    cursor: "pointer"
  },
  listHeader:{
    display: "flex",
    flex: "1",
    alignItems: "center",
  },
  listType: {
    height: "24px",
    width: "48px",
    boxSizing: "border-box",
    borderRadius: "16px", 
    backgroundColor: "var(--main-red_10)",
    display: "flex",
    alignItems: "center",
    color : "var(--main-red_70)",
    marginRight : "20px",
    padding: "0px 12px",
  },
  meta: {
    fontSize: "12px",
    color: "#888",
  },  
};

export default MyPageAnnounceBoard;